import moment from 'moment';
import i18n from '@/i18n';

export function date (date, format = 'YYYY年MM月DD日') {
  if (date) {
    return moment(date).format(format);
  }
  return '';
}

export function time (date, format = 'HH:mm') {
  if (date) {
    return moment(date).format(format);
  }

  return '';
}

export function datetime (datetime, formatDatetime = 'YYYY/MM/DD HH:mm') {
  if (datetime) {
    return moment(datetime).format(formatDatetime);
  }
  return '';
}

export function number (value, type = 'decimal', locale = 'ja-JP') {
  if (value) {
    return i18n.n(value, type, locale);
  }
  return '';
}


export function shortDate (date, format = 'short', locale = 'ja') {
  if (date) {
    return i18n.d(new Date(date), format, locale);
  }
  return '';
}

export function longDate (date, format = 'long', locale = 'ja') {
  if (date) {
    return i18n.d(new Date(date), format, locale);
  }
  return '';
}

export function longDateWithJP (datetime, formatDatetime = 'YYYY年MM月DD日') {
  if (datetime) {
    return moment(datetime).format(formatDatetime);
  }
  return '';
}

export function durationHours (durationTotal) {
  if (! durationTotal) return durationTotal;
  const hourPart = Math.floor(durationTotal);
  const minutesPart = (durationTotal - hourPart).toFixed(3) * 60;
  const result = [];

  if (hourPart) {
    result.push(hourPart + '時間');
  }

  if (minutesPart) {
    result.push(minutesPart + '分');
  }

  return result.join('');
}

export function dateWithWeekDay(date, format = 'YYYY年M月D日 (ddd)') {
  moment.locale('ja');

  return moment(date).format(format);
}
